<template lang="pug">
div
    Card.a8-page-description-card
            Row(:gutter="16" type="flex" justify="space-between")
                Col(span="12")
                    h2 {{ $t('intelligent.pageTitleText') }}
                    p {{ $t('intelligent.pageSubtitleText') }}
                Col(span="12")
                    RadioGroup(v-model="selectedRadio")
                        List(size="small" border)
                            ListItem(v-for="item in radioList" :key="item.key")
                                ListItemMeta
                                    template(slot="avatar")
                                        Radio(:label="item.key" :disabled="item.disabled")
                                            span
                                    template(slot="title")
                                        span {{item.title}}
                                    template(slot="description")
                                        span {{item.description}}
                                        template(v-if="currentGroupConfig")
                                            Alert(v-if="isShowAlert(item)" type="warning" show-icon) {{ alertText(item) }}
                                        Spin(v-else)
    template(v-if="selectedRadio === 'settings'")
        IntelligentProtectionSettings(:searchView="searchView")
    template(v-if="selectedRadio === 'events'")
        Row(style="padding-bottom: 4px;")
            Col(:lg="24" :md="24" :sm="24")
                Card(:dis-hover="true" style="max-height: 300px; overflow-y: auto;")
                    div(style="margin-bottom: 4px;")
                        span(style="margin-right: 8px;") {{ $t("intelligent.dataTimeRange") }}
                        Select(
                            v-model="selectedTimeRange"
                            style="width: 120px"
                            @on-change="onTimeRangeChange"
                        )
                            Option(v-for="item in timeRangeOptions" :value="item.value" :key="item.value") {{ item.label }}
                    Table(:class="tableHeaderStyle" height="200" :columns="columns" :data="eventIds" :no-data-text="$t('intelligent.tableNoDataText')")
                        template(#select="{ row }")
                            Checkbox(v-model="row.select" @on-change="checkboxOnChange(row)" :disabled="row.select")
                        template(#abnormalTime="{ row }")
                            p {{ moment(row.abnormal_time).format("YYYY-MM-DD HH:mm:ss") }}
                        template(#RuleScore="{ row }")
                            icon(type="ios-radio-button-on" :style="setRuleColor(row)")
                            span &emsp;
                            span {{ row.rule_score.toFixed(2) }}
                        template(#AffectedRatio="{ row }")
                            p {{ `${(row.abnormal.affected_ratio *100).toFixed(2)} %` }}
                        template(#Rule="{ row }")
                            JsonPoptip(
                                :title="row.rule_id"
                                :jsonData="`[${JSON.stringify(row.rule)}]`"
                                buttonText=""
                                buttonIcon="md-eye"
                            )
                        template(#RuleText="{ row }")
                            JsonPoptip(
                                :title="row.rule_id"
                                :jsonData="`${row.rule_text}`"
                                buttonText=""
                                buttonIcon="md-eye"
                                :withCopyButton="true"
                            )
        Row
            Col(span="24")
                LineChartDDosAnalyze(
                    v-if="showDashBoard"
                    :ddosAnalyzeId="ddosAnalyzeIds[ddosAnalyzeIds.length - 1]"
                    :selectedAbnormalTime="selectedAbnormalTime"
                )
</template>

<script>
import IntelligentProtectionSettings from "@/view/IntelligentProtectionSettings/Page.vue";
import moment from "moment";
import LineChartDDosAnalyze from "@/components/dashboard/LineChartDDosAnalyze";
import JsonPoptip from "@/components/JsonPoptip";

import { getDdosAnalyzeChartDataList } from "@/api/monitor.js";
import { colorNames } from "@/libs/rcmTableFieldsFunction";

export default {
    name: "IntelligentProtection",
    components: {
        IntelligentProtectionSettings,
        LineChartDDosAnalyze,
        JsonPoptip,
    },
    data() {
        return {
            showDashBoard: false,
            eventIds: [],
            ddosAnalyzeIds: [],
            showCompareModal: false,
            columns: [
                {
                    title: " ",
                    align: "center",
                    slot: "select",
                    width: 50,
                },
                {
                    title: " ",
                    align: "center",
                    width: 50,
                    renderHeader: (h, params) => {
                        return h(
                            "Tooltip",
                            {
                                props: {
                                    placement: "top",
                                    transfer: true,
                                    maxWidth: "300px",
                                    content: this.$t("intelligent.applyWafTooltipContent"),
                                },
                            },
                            [
                                h("Icon", {
                                    props: {
                                        type: "ios-help-circle-outline",
                                    },
                                    style: {
                                        cursor: "pointer",
                                        fontSize: "16px",
                                    },
                                }),
                            ]
                        );
                    },
                    render: (h, params) => {
                        if (!params.row.apply_waf) return null;
                        return h("icon", {
                            props: {
                                type: "md-medal",
                                color: colorNames.orange,
                                size: 24,
                            },
                        });
                    },
                },
                {
                    title: this.$t("intelligent.abnormalTime"),
                    key: "abnormal_time",
                    align: "center",
                    slot: "abnormalTime",
                    width: 170,
                    sortable: true,
                },
                {
                    title: this.$t("intelligent.ruleId"),
                    key: "rule_id",
                    align: "center",
                    width: 200,
                },
                {
                    title: this.$t("intelligent.group"),
                    key: "group",
                    align: "center",
                    width: 170,
                },
                {
                    title: this.$t("intelligent.serverName"),
                    key: "server_name",
                    align: "center",
                    width: 200,
                },
                {
                    align: "center",
                    width: 150,
                    slot: "AffectedRatio",
                    renderHeader: (h, params) => {
                        return h("div", [
                            h("span", `${this.$t("intelligent.affectedRatio")} `),
                            h(
                                "Tooltip",
                                {
                                    props: {
                                        placement: "top",
                                        transfer: true,
                                        maxWidth: "300px",
                                    },
                                },
                                [
                                    // slot="content"
                                    h(
                                        "div",
                                        {
                                            slot: "content",
                                        },
                                        [
                                            h("p", [
                                                `${this.$t("intelligent.affectedRatioTipPrefix")} `,
                                                h("mark", this.$t("intelligent.affectedRatioMarkTip")),
                                                ` ${this.$t("intelligent.affectedRatioTipSuffix")}`,
                                            ]),
                                            h("p", this.$t("intelligent.affectedRatioNoticeTips")),
                                        ]
                                    ),
                                    // Tooltip trigger
                                    h("Icon", {
                                        props: {
                                            type: "ios-help-circle-outline",
                                        },
                                        style: {
                                            cursor: "pointer",
                                            fontSize: "16px",
                                        },
                                    }),
                                ]
                            ),
                        ]);
                    },
                },
                {
                    align: "center",
                    width: 150,
                    slot: "RuleScore",
                    renderHeader: (h, params) => {
                        return h("div", [
                            h("span", `${this.$t("intelligent.ruleScore")} `),
                            h(
                                "Tooltip",
                                {
                                    props: {
                                        placement: "top",
                                        transfer: true,
                                        maxWidth: "300px",
                                    },
                                },
                                [
                                    // slot="content"
                                    h(
                                        "div",
                                        {
                                            slot: "content",
                                        },
                                        [h("p", this.$t("intelligent.ruleScoreTip"))].concat(
                                            [
                                                { color: "green", text: `${this.$t("intelligent.ruleScore")} ≥ 4` },
                                                {
                                                    color: "yellow",
                                                    text: `4 > ${this.$t("intelligent.ruleScore")} ≥ 3`,
                                                },
                                            ].map((item) => {
                                                return h(
                                                    "div",
                                                    {
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                        },
                                                    },
                                                    [
                                                        h("Icon", {
                                                            props: {
                                                                type: "ios-radio-button-on",
                                                                color: item.color,
                                                                size: 16,
                                                            },
                                                        }),
                                                        h("p", item.text),
                                                    ]
                                                );
                                            })
                                        )
                                    ),
                                    // Tooltip trigger
                                    h("Icon", {
                                        props: {
                                            type: "ios-help-circle-outline",
                                        },
                                        style: {
                                            cursor: "pointer",
                                            fontSize: "16px",
                                        },
                                    }),
                                ]
                            ),
                        ]);
                    },
                },
                {
                    title: this.$t("intelligent.rule"),
                    align: "center",
                    slot: "Rule",
                    width: 80,
                },
                {
                    title: this.$t("intelligent.ruleText"),
                    align: "center",
                    slot: "RuleText",
                    width: 100,
                },
            ],
            moment: moment,
            selectedAbnormalTime: "", // row 的異常時間
            selectedTimeRange: "30m",
            timeRangeOptions: [
                { label: this.$t("intelligent.timeRange.30m"), value: "30m" },
                { label: this.$t("intelligent.timeRange.1h"), value: "1h" },
                { label: this.$t("intelligent.timeRange.4h"), value: "4h" },
                { label: this.$t("intelligent.timeRange.1d"), value: "1d" },
                { label: this.$t("intelligent.timeRange.3d"), value: "3d" },
                { label: this.$t("intelligent.timeRange.7d"), value: "7d" },
                { label: this.$t("intelligent.timeRange.30d"), value: "30d" },
            ],
            selectedRadio: "events",
            searchView: "DDoSAnalyze",
        };
    },
    methods: {
        async onTimeRangeChange() {
            await this.getDdosAnalyzeIds()
            this.reShow();
        },
        // 取得所有ruleId,並預設第一個值
        async getDdosAnalyzeIds() {
            const result = await getDdosAnalyzeChartDataList({
                groupName: this.$store.state.queryGroupName,
                searchTimeRange: this.selectedTimeRange,
            });
            const eventList = result.data;
            if (eventList.success) {
                this.eventIds = eventList.mapData;
            }

            // 抓取最近的ruleId
            const firstId = (this.eventIds[0] || {}).rule_id;
            this.ddosAnalyzeIds = [firstId];
            this.eventIds = this.eventIds.map((item) => ({
                ...item,
                select: item.rule_id === firstId,
            }));

            // 同步初始化「選到的異常時間」
            if (this.eventIds[0]) this.selectedAbnormalTime = this.eventIds[0].abnormal_time || "";
        },
        // 異動checkbox的動作
        checkboxOnChange(row) {
            // 將選到的異常時間記錄下來
            this.selectedAbnormalTime = row.abnormal_time;

            // 製作只能選單一報表
            this.eventIds = this.eventIds.map((item, index) => {
                item.select = false;
                if (row._index === index) {
                    item.select = row.select;
                }
                return item;
            });
            this.ddosAnalyzeIds = this.eventIds.filter((item) => item.select === true).map((item) => item.rule_id);

            this.reShow();
        },
        // 重新渲染報表
        reShow() {
            // 查無ids，不顯示下方圖表及規則
            if (this.eventIds.length === 0) {
                return (this.showDashBoard = false);
            }
            this.showDashBoard = false;
            this.$nextTick(() => {
                this.showDashBoard = true;
            });
        },
        // 設定規則分數顏色
        setRuleColor(row) {
            let color = "yellow";
            if (row.rule_score >= 4) {
                color = "green";
            }
            return { color };
        },
        isShowAlert(item) {
            if (this.$store.state.queryGroupName === "all") {
                return false;
            }
            if (item.key === "settings") {
                return !this.isEnabledSettings;
            }
            if (item.key === "events") {
                return !this.isEnabledAutoWaf;
            }
            return false;
        },
        alertText(item) {
            const groupName = this.$store.state.queryGroupName;
            const keyMap = {
                settings: "intelligent.settingsIsNotEnabledText",
                events: "intelligent.autoWafIsNotEnabledText",
            };
            const i18nKey = keyMap[item.key];
            return i18nKey ? this.$t(i18nKey, { groupName }) : "";
        },
        getCurrentGroupConfigByLabel(label) {
            if (!this.currentGroupConfig || !this.currentGroupConfig.subItems) {
                return null;
            }
            return (
                this.currentGroupConfig.subItems.find((item) => {
                    return item.label === label;
                }) || null
            );
        },
    },
    computed: {
        currentGroupConfig() {
            const configs = this.$store.state.platformPlan.multiTenancyConfigs.intelligentProtectionSettings || [];
            return (
                configs.find((config) => config.groupName === this.$store.state.queryGroupName) ||
                configs.find((config) => config.groupName === "all") ||
                null
            );
        },
        // 是否禁用白名單的 radio
        isDisabledSettings() {
            const currentLabel = this.getCurrentGroupConfigByLabel("DDoSAnalyzeSetting");
            if (!currentLabel) return false;
            return !currentLabel.isShow;
        },
        // 白名單分頁下設置的規則是否生效
        isEnabledSettings() {
            const currentLabel = this.getCurrentGroupConfigByLabel("DDoSAnalyzeSetting");
            if (!currentLabel) return false;
            return currentLabel.isEnabled;
        },
        // 事件分頁下 auto waf 是否生效
        isEnabledAutoWaf() {
            const currentLabel = this.getCurrentGroupConfigByLabel("DDoSAnalyze");
            if (!currentLabel) return false;
            return currentLabel.isEnabled;
        },
        radioList() {
            return [
                {
                    key: "settings",
                    title: this.$t("intelligent.settingsTitle"),
                    description: this.$t("intelligent.settingsDescription"),
                    disabled: this.isDisabledSettings,
                },
                {
                    key: "events",
                    title: this.$t("intelligent.eventsTitle"),
                    description: this.$t("intelligent.eventsDescription"),
                    disabled: false,
                },
            ];
        },
        tableHeaderStyle() {
            return this.$store.getters.getTableConfig.headerStyle;
        },
    },
    mounted() {},
    async created() {
        await this.getDdosAnalyzeIds();
        this.reShow();
    },
};
</script>



// WEBPACK FOOTER //
// src/view/dashboard/IntelligentProtection.vue